export default __webpack_public_path__ + "static/team_newbg-a29337809b80fe67f7de2e2c2eebf70e.jpg";